import { clientOnlyLazy } from '#/utils/clientOnlyLazy';

export const ClientOnlyLazyListingViewAdminTools = clientOnlyLazy(() =>
  import('./ListingViewAdminTools').then((m) => ({
    default: m.ListingViewAdminTools,
  })),
);
